class Quote {
    static register = {
       QT_VIEW : {slug: 'QT_VIEW'}, // Submitted Quotes
       OPEN_QT_VIEW: {slug:'OPEN_QT_VIEW'},  // Open Quotes
       QT_BUY_NOW: {slug: 'QT_BUY_NOW'},
       QT_CART_VIEW: {slug:'QT_CART_VIEW'},
       QT_CHECKOUT: {slug: 'QT_CHECKOUT'}
    };
}

export default Quote;